/**
 * Middleware that handles old product query values and replaces them with their replacements.
 */
export default defineNuxtRouteMiddleware((to) => {
  const { format, ...query } = to.query

  const formats = (Array.isArray(format) ? format : [format]).filter(truthyAndDistinct)
  if (!formats.length) {
    return
  }

  const replaced: ProductFormat[] = []
  let changed = false
  for (const rawFormat of formats) {
    switch (rawFormat) {
      case 'nettsted': {
        changed = true
        replaced.push(
          'digitalressurs_laerer',
          'digitalressurs_elev',
        )
        break
      }
      case 'unibok': {
        changed = true
        replaced.push('digitalbok')
        break
      }
      case 'laererprodukt':
        changed = true
        replaced.push('laerermateriell')
        break
      default: {
        const format = PRODUCT_FORMATS.find((it) => it === rawFormat)
        if (format) {
          // Adding one that was already present, so no change
          replaced.push(format)
        } else {
          // The implication here is that we've removed a format, so there's been a change
          changed = true
        }
      }
    }
  }

  if (changed) {
    return navigateTo({
      ...to,
      query: {
        ...query,
        format: replaced,
      },
    })
  }
})
